import axios from 'axios'

export default {
    namespaced: true,

    state: {
        profile:null,
        authenticated: null,
        user: null,
        mustLogin: false,
        emailUser: '',
        userProfile: {},
        isValidateField: false,
        keyResetPassword: null,
        hittingLimit: '',
        sortingLimit: '',
        clickerLimit: '',
        previousPage: ''
    },

    getters: {
        authenticated(state) {
            return state.authenticated
        },

        user(state) {
            return state.user
        },
    },

    mutations: {
        SET_USER_PROFILE(state, value) {
            state.userProfile = value;
        },
        SET_VALIDATE(state, value) {
            state.isValidateField = value;
        },
        SET_AUTHENTICATED(state, value) {
            state.authenticated = value
        },

        SET_USER(state, value) {
            state.user = value
        },
        SET_PROFILE(state, value) {
            state.profile = value
        },
        SET_EMAIL(state, email) {
            state.emailUser = email;
        },
        MUST_LOGIN(state, value) {
            if(value === true){
                state.mustLogin = Math.random()
            }
            else{
                state.mustLogin = false
            }

        },
        SET_KEY_PASSWORD(state, value) {
            state.keyResetPassword = value;
        },
        SET_HITTING_LIMIT(state, limit) {
            state.hittingLimit = limit;
        },
        SET_SORTING_LIMIT(state, limit) {
            state.sortingLimit = limit;
        },
        SET_CLICKER_LIMIT(state, url) {
            state.clickerLimit = url;
        },
        SET_PREVIOUS_PAGE(state, value) {
            state.previousPage = value;
        },
    },

    actions: {
        async signIn({dispatch,commit}, credentials) {
            await axios.get('/sanctum/csrf-cookie')
            await axios.post('/login', credentials)
            await axios.get("/api/profile").then(response => {
                const profile = response.data
                if(profile.completedStage2){
                    commit("SET_PROFILE",2)
                }
                else if(profile.completedStage1){
                    commit("SET_PROFILE",1)
                }
                if(profile.email) {
                    this.$store.commit("auth/SET_EMAIL", profile.email)
                }
            })
            return dispatch('me')
        },

        async signOut({dispatch}) {
            await axios.post('/logout')
            return dispatch('me')
        },

        me({commit}) {
            return axios.get('/api/user').then((response) => {
                commit('SET_AUTHENTICATED', true)
                commit('SET_USER', response.data)
            }).catch(() => {
                commit('SET_AUTHENTICATED', false)
                commit('SET_USER', null)
            })
        }
    }
}
